import { useEffect } from 'react';
import useUser from 'hooks/useUser';
import useExposureEvent from 'hooks/useExposureEvent';

export default function useAdaChatbotExposure(menuIsOpen: boolean): void {
  const user = useUser();
  const sendExposure = useExposureEvent('web-growth-rm-global-ada-chatbot-support');

  useEffect(() => {
    if (user && menuIsOpen) {
      sendExposure();
    }
  }, [user, sendExposure, menuIsOpen]);
}
